import { render, staticRenderFns } from "./Officers.vue?vue&type=template&id=593dd98e&"
import script from "./Officers.vue?vue&type=script&lang=js&"
export * from "./Officers.vue?vue&type=script&lang=js&"
import style0 from "./Officers.vue?vue&type=style&index=0&id=593dd98e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports